import { render, staticRenderFns } from "./informationOnOfficialSite.vue?vue&type=template&id=4aab4884&"
import script from "./informationOnOfficialSite.vue?vue&type=script&lang=js&"
export * from "./informationOnOfficialSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports